<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <div class="logo-image-container">
    <img src="assets/img/travelex.png" class="logo-image">
  </div>
  <mat-card class="auth-view" id="auth-view">
    <router-outlet></router-outlet>
  </mat-card>
</div>
